import React from "react";
import Header from "../Components/Header";
import BannerComp from "../Components/BannerComp";
import "../Css/ContactUs.css";
import Footer from "../Components/Footer";
import { NavLink } from "react-router-dom";

import { Fade } from "react-awesome-reveal";
import { AiOutlineLinkedin, AiOutlinePinterest } from "react-icons/ai";
import { TiSocialInstagram } from "react-icons/ti";
import { IoLogoFacebook } from "react-icons/io";
import { Button, Form, message } from "antd";
import { useCartContext } from "../context/addToCart";
import { MetaTags } from "react-meta-tags";

export default function ContactUs() {
  const { makeAndEnquiry } = useCartContext();
  const [form] = Form.useForm();

  const onFinish = (val) => {
    if (
      makeAndEnquiry(
        val.name,
        val.number,
        val.email,
        val.message,
        "Contact Enquiry",
        null,
        null,
        null
      )
    ) {
      message.success(
        "Thank you for your inquiry. Our team will connect with you shortly."
      );
      form.resetFields();
    }
  };

  return (
    <>
    <MetaTags>
        <title>Best Diamond Dealer | Sejal Exports</title>
        <meta title="Best Diamond Dealer | Sejal Exports" />
        <meta name="description" content="Find the Best Diamond Dealer for top-quality diamonds at unbeatable prices. Whether you're a jeweller or collector, explore our wide range of diamonds." />
        <meta name="keywords" content="Melee Diamonds For Jewellery,Best Diamonds Collection ,Diamond Wholesaler ,Fancy Color Diamonds ,Melee Diamonds,Certified Melee Diamonds,Fancy Diamonds With Different Shape,Black Diamonds ,Certified Diamonds,Customized Diamonds,Certified Fancy diamond,Natural Diamonds ,Calibrated Diamonds ,Best Ntural Diamond Supplier ,Best Natural Diamond Exhibition ,Best Natural Diamond Dealer,Reasonable Diamond In USA,Fast Delivery Diamonds ,High Quality Diamond In USA,Best Diamond Company In USA,Diamond For Jewelry In USA,cheapest Rate Diamond In USA,Natural Melee Diamond In USA,Reasonable Diamond In UK,Fast Delivery ,High Quality Diamond In UK,Best Diamond Company In UK,Diamond For Jewellery In UK,cheapest Rate Diamond In UK,Melee Diamond In UK,Reasonable Diamond In Canada,Fast Delivery ,High Quality Diamond In Canada,Best Diamond Company In Canada,Diamond For Jewellery In Canada,cheapest Rate Diamond In Canada,Melee Diamond In Canada,Reasonable Diamond In Australia,Fast Delivery ,High Quality Diamond In Australia,Best Diamond Company In Australia,Diamond For Jewellery In Australia,cheapest Rate Diamond In Australia,Melee Diamond In Australia,Reasonable Diamante In Mexico,Fast Delivery ,High Quality Diamante In Mexico,Best Diamante Company In Mexico,Diamante For joyas In Mexico,cheapest Rate Diamante In Mexico,Melee Diamante In Mexico,Reasonable Diamante In Columbia,Fast Delivery ,High Quality Diamante In Columbia,Best Diamante Company In Columbia,Diamante For joyas In Columbia,cheapest Rate Diamante In Columbia,Melee Diamante In Columbia,Reasonable Diamante In Italy,Fast Delivery ,High Quality Diamante In Italy,Best Diamante Company In Italy,Diamante For gioielli In Italy,cheapest Rate Diamante In Italy,Melee Diamante In Italy,Reasonable Diamant In France,Fast Delivery ,High Quality Diamant In France,Best Diamant Company In France,Diamant For bijoux In France,cheapest Rate Diamant In France,Melee Diamant In France,Reasonable Diamant In Germany,Fast Delivery ,High Quality Diamant In Germany,Best Diamant Company In Germany,Diamant For Schmuck In Germany,cheapest Rate Diamant In Germany,Melee Diamant In Germany,Reasonable diamant In Denmark,Fast Delivery ,High Quality diamant In Denmark,Best diamant Company In Denmark,diamant For Schmuck In Denmark,cheapest Rate diamant In Denmark,Melee diamant In Denmark,Reasonable diamant In Sweden,Fast Delivery ,High Quality diamant In Sweden,Best diamant Company In Sweden,diamant For smycke In Sweden,cheapest Rate diamant In Sweden,Melee diamant In Sweden,Reasonable Diamond In South Africa,Fast Delivery ,High Quality Diamond In South Africa,Best Diamond Company In South Africa,Diamond For Jewellery In South Africa,cheapest Rate Diamond In South Africa,Melee Diamond In South Africa,Reasonable Diamond In Hong Kong,Fast Delivery ,High Quality Diamond In Hong Kong,Best Diamond Company In Hong Kong,Diamond For Jewellery In Hong Kong,cheapest Rate Diamond In Hong Kong,Melee Diamond In Hong Kong,Reasonable Diamond In Dubai,Fast Delivery ,High Quality Diamond In Dubai,Best Diamond Company In Dubai,Diamond For Jewellery In Dubai,cheapest Rate Diamond In Dubai,Melee Diamond In Dubai,Reasonable Diamond In Malaysia,Fast Delivery ,High Quality Diamond In Malaysia,Best Diamond Company In Malaysia,Diamond For Jewellery In Malaysia,cheapest Rate Diamond In Malaysia,Melee Diamond In Malaysia,Reasonable Diamond In Singapore,Fast Delivery ,High Quality Diamond In Singapore,Best Diamond Company In Singapore,Diamond For Jewellery In Singapore,cheapest Rate Diamond In Singapore,Melee Diamond In Singapore,Reasonable Diamond In Thailand,Fast Delivery ,High Quality Diamond In Thailand,Best Diamond Company In Thailand,Diamond For Jewellery In Thailand,cheapest Rate Diamond In Thailand,Melee Diamond In Thailand,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia" />
        <link rel="canonical" href="https://sejalexports.in/best-diamond-dealer" />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content="Best Diamond Dealer | Sejal Exports" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sejalexports.in/" />
        <meta property="og:description" content="Find the Best Diamond Dealer for top-quality diamonds at unbeatable prices. Whether you're a jeweller or collector, explore our wide range of diamonds." />
        <meta property="og:image" content="https://sejalexports.in/static/media/logo.3d243a21eddc9f360630.png" />
      </MetaTags>
      <Header />
      <BannerComp
        title="Contact Us"
        image="https://t4.ftcdn.net/jpg/03/95/04/15/360_F_395041586_h21AxqD0dNjxUw3lKFiV5t7qMBJs6wfe.jpg"
        breadcrumb={[
          {
            title: "Home",
            href: "/",
          },
          {
            title: "Contact Us",
          },
        ]}
      />
      <section className="sectionDiv contactUs w-100 ">
        <div className="container">
          <span className="big-circle" />
          <img src="img/shape.png" className="square" alt="" />
          <div className="form">
            <Fade triggerOnce direction="left">
              <div className="contact-info">
                <h3 className="title">Let's get in touch</h3>
                <p className="text">
                  At Sejal Exports, we are committed to providing exceptional
                  customer service and high-quality products. If you have any
                  questions, need further information about our products, or
                  wish to place a custom order, our team is here to assist you.
                </p>
                <div className="info">
                  <div className="information">
                    <i className="fas fa-map-marker-alt" /> &nbsp; &nbsp;
                    <p>
                    C- East 4011, BDB, opposite NABARD, G Block, Bandra Kurla Complex, Bandra East, Mumbai, Maharashtra 400051
                    </p>
                  </div>
                  <div className="information">
                    <i className="fas fa-envelope" /> &nbsp; &nbsp;
                    <p className="m-0"><NavLink to="mailto:websales@sejalgems.in">websales@sejalgems.in</NavLink></p>
                  </div>
                  <div className="information">
                    <i className="fas fa-phone" />
                    &nbsp;&nbsp;
                    <p className="m-0"><NavLink to="tel:+91 (0) 022 4043 1111">+91 (0) 022 4043 1111</NavLink></p>
                  </div>
                </div>
                <div className="social-media">
                  <p>Connect with us :</p>
                  <div className="social-icons">
                    <NavLink
                      to="https://www.linkedin.com/company/sejal-exports-india/mycompany/"
                      target="_blank"
                    >
                      <AiOutlineLinkedin />
                    </NavLink>

                    <NavLink
                      to="https://in.pinterest.com/natural_diamondss/"
                      target="_blank"
                    >
                      <AiOutlinePinterest />
                    </NavLink>

                    <NavLink
                      to="https://www.instagram.com/naturalmeleediamonds/"
                      target="_blank"
                    >
                      <TiSocialInstagram />
                    </NavLink>

                    <NavLink
                      to="https://www.facebook.com/meleediamondsupplier "
                      target="_blank"
                    >
                      <IoLogoFacebook />
                    </NavLink>
                  </div>
                </div>
              </div>
            </Fade>
            <Fade triggerOnce direction="right">
              <div className="contact-form">
                <span className="circle one" />
                <span className="circle two" />
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={onFinish}
                  autoComplete="off"
                >
                  <h3 className="title">Contact us</h3>
                  <Form.Item
                    className="m-0"
                    name="name"
                    rules={[{ required: true }]}
                  >
                    <div className="input-container mb-1">
                      <input
                        type="text"
                        name="name"
                        placeholder="Full Name"
                        className="input"
                      />
                    </div>
                  </Form.Item>
                  <Form.Item
                    className="m-0"
                    name="email"
                    rules={[{ required: true }]}
                  >
                    <div className="input-container mb-1">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email Id"
                        className="input"
                      />
                    </div>
                  </Form.Item>
                  <Form.Item
                    className="m-0"
                    name="number"
                    rules={[{ required: true }]}
                  >
                    <div className="input-container mb-1">
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Phone Number"
                        className="input"
                      />
                    </div>
                  </Form.Item>
                  <Form.Item
                    className="m-0"
                    name="message"
                    rules={[{ required: true }]}
                  >
                    <div className="input-container mb-5 textarea">
                      <textarea
                        name="message"
                        placeholder="Message"
                        className="input"
                      />
                    </div>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      style={{ height: 40, width: 150 }}
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Fade>
          </div>
        </div>
        <Fade triggerOnce direction="up">
          <div className="container mt-5">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.891943187246!2d72.86770557544116!3d19.068487982134606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c8de2609ab25%3A0x84fd783980310eb5!2sSejal%20Exports%20(India)%20100%25%20Natural%20Diamonds!5e0!3m2!1sen!2sin!4v1728559742916!5m2!1sen!2sin"
              width="100%"
              height={350}
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map"
            />
          </div>
        </Fade>
      </section>

      <Footer />
    </>
  );
}
